/** Curated palette — matches the board status token hues. */
export const STAGE_COLOR_PRESETS = [
  "#3B82F6",
  "#8B5CF6",
  "#F59E0B",
  "#22C55E",
  "#EF4444",
  "#06B6D4",
  "#EC4899",
  "#6366F1",
  "#84CC16",
  "#F97316",
];

const SHORT_HEX = /^#([0-9A-Fa-f]{3})$/;
const FULL_HEX = /^#([0-9A-Fa-f]{6})$/;

/** Normalize user input to `#RRGGBB`, or null when invalid / empty. */
export const normalizeStageColor = (value) => {
  if (value == null || value === "") return null;
  const trimmed = String(value).trim();
  if (trimmed === "") return null;

  const full = trimmed.match(FULL_HEX);
  if (full) return `#${full[1].toUpperCase()}`;

  const short = trimmed.match(SHORT_HEX);
  if (short) {
    const [r, g, b] = short[1].split("");
    return `#${r}${r}${g}${g}${b}${b}`.toUpperCase();
  }

  return null;
};
